import Layout from "@/components/Layout";

const TermsOfService = () => {
  return (
    <Layout>
      <section className="py-16 lg:py-20" id="terms-of-service">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="space-y-8">
            <div className="text-center space-y-4">
              <h1 className="text-4xl lg:text-5xl font-bold text-foreground">
                Terms of Service
              </h1>
              <p className="text-muted-foreground">
                Last updated: 26 September, 2025.
              </p>
            </div>

            <div className="prose prose-lg max-w-none space-y-8">
              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-foreground">
                  1. Acceptance of Terms
                </h2>
                <div className="space-y-3 text-muted-foreground">
                  <p>
                    By accessing and using TCLA-X services, you accept and agree
                    to be bound by the terms and provision of this agreement. If
                    you do not agree to abide by the above, please do not use
                    this service.
                  </p>
                </div>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-foreground">
                  2. Service Description
                </h2>
                <div className="space-y-3 text-muted-foreground">
                  <p>
                    TCLA-X provides capacity building, training, coaching, and
                    mentorship services to individuals and organizations. Our
                    services include but are not limited to:
                  </p>
                  <ul className="list-disc pl-6 space-y-2">
                    <li>Leadership development programs</li>
                    <li>Project management training</li>
                    <li>Professional development courses</li>
                    <li>Organizational consulting</li>
                    <li>Online and in-person training delivery</li>
                  </ul>
                </div>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-foreground">
                  3. User Responsibilities
                </h2>
                <div className="space-y-3 text-muted-foreground">
                  <p>Users agree to:</p>
                  <ul className="list-disc pl-6 space-y-2">
                    <li>
                      Provide accurate and complete information during
                      registration
                    </li>
                    <li>Maintain the confidentiality of account credentials</li>
                    <li>Use services only for lawful purposes</li>
                    <li>Respect intellectual property rights</li>
                    <li>
                      Participate actively and professionally in training
                      programs
                    </li>
                    <li>
                      Not share access credentials with unauthorized parties
                    </li>
                  </ul>
                </div>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-foreground">
                  4. Payment Terms
                </h2>
                <div className="space-y-3 text-muted-foreground">
                  <p>
                    Payment for services must be made according to the agreed
                    schedule. Late payments may result in suspension of
                    services. All fees are non-refundable unless otherwise
                    specified in our Refund Policy.
                  </p>
                  <p>
                    Corporate clients may be offered customized payment terms
                    based on the scope and duration of services.
                  </p>
                </div>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-foreground">
                  5. Intellectual Property
                </h2>
                <div className="space-y-3 text-muted-foreground">
                  <p>
                    All content, materials, and intellectual property provided
                    through TCLA-X services remain the property of TCLA-X
                    Limited. Users are granted a limited, non-exclusive license
                    to access and use materials for personal or organizational
                    development purposes only.
                  </p>
                  <p>
                    Reproduction, distribution, or commercial use of materials
                    without explicit written permission is prohibited.
                  </p>
                </div>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-foreground">
                  6. Service Availability
                </h2>
                <div className="space-y-3 text-muted-foreground">
                  <p>
                    We strive to maintain service availability but cannot
                    guarantee uninterrupted access. Services may be temporarily
                    unavailable due to maintenance, updates, or technical
                    issues.
                  </p>
                  <p>
                    We reserve the right to modify, suspend, or discontinue
                    services with reasonable notice to users.
                  </p>
                </div>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-foreground">
                  7. Limitation of Liability
                </h2>
                <div className="space-y-3 text-muted-foreground">
                  <p>
                    TCLA-X Limited shall not be liable for any indirect,
                    incidental, special, or consequential damages arising from
                    the use of our services. Our total liability is limited to
                    the amount paid for the specific service in question.
                  </p>
                </div>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-foreground">
                  8. Termination
                </h2>
                <div className="space-y-3 text-muted-foreground">
                  <p>
                    Either party may terminate the service agreement with
                    appropriate notice. TCLA-X reserves the right to terminate
                    services immediately for breach of terms or inappropriate
                    behavior.
                  </p>
                </div>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-foreground">
                  9. Governing Law
                </h2>
                <div className="space-y-3 text-muted-foreground">
                  <p>
                    These terms are governed by the laws of Kenya. Any disputes
                    shall be resolved through the courts of Kenya or through
                    arbitration as mutually agreed.
                  </p>
                </div>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-foreground">
                  10. Contact Information
                </h2>
                <div className="space-y-3 text-muted-foreground">
                  <p>
                    For questions regarding these Terms of Service, please
                    contact us at:
                  </p>
                  <div className="bg-muted/30 p-4 rounded-lg">
                    <p>
                      <strong>TCLA-X Limited</strong>
                    </p>
                    <p>Email: info@tcla-x.com</p>
                    <p>Phone: +254722 319 499</p>
                    <p>Address: Nairobi, Kenya</p>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default TermsOfService;
